import { useState } from "react";

interface OrderSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  productName: string;
}

export default function OrderSuccessModal({
  isOpen,
  onClose,
  productName,
}: OrderSuccessModalProps) {
  const [orderNumber] = useState(() =>
    Math.random().toString(36).substring(2, 10).toUpperCase()
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 p-6 md:p-8 text-center animate-fadeIn">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-stone-100 transition-colors"
        >
          <i className="ri-close-line text-stone-500" />
        </button>

        <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
          <i className="ri-check-double-line text-emerald-600 text-2xl" />
        </div>

        <h2 className="font-display text-xl md:text-2xl font-bold text-stone-800 mb-2">
          認購成功！
        </h2>
        <p className="font-body text-xs md:text-sm text-stone-500 mb-4">
          感謝你的支持，{productName} 的認購已確認。
        </p>

        <div className="bg-stone-50 rounded-xl p-4 mb-4">
          <p className="font-body text-xs text-stone-500 mb-1">訂單編號</p>
          <p className="font-display text-sm font-bold text-stone-800 tracking-wider">
            #SS{orderNumber}
          </p>
        </div>

        <p className="font-body text-xs text-stone-400 mb-5">
          訂單詳情已記錄至你的會員帳號，可隨時於「我的訂單」查閱
        </p>

        <button
          onClick={onClose}
          className="w-full font-body text-sm font-semibold py-3 rounded-full bg-rose-800 text-white hover:bg-rose-900 transition-colors whitespace-nowrap"
        >
          繼續瀏覽
        </button>
      </div>
    </div>
  );
}